
<main>
    <div class="notificationList">
        <div class="main-members donor-members" *ngFor="let data of notificationList">
            <a class="member-list-item" (click)="notificationIsRead(data)">
                <div>
                    <h5>{{data.notification_title}}</h5>
                    <h6>{{data.description}}</h6>
                    <!-- <span class="text-success"></span> -->
                </div>
            </a>
        </div>
    </div>
</main>